import { render, staticRenderFns } from "./AboutProducts.vue?vue&type=template&id=82269f9e&"
import script from "./AboutProducts.vue?vue&type=script&lang=js&"
export * from "./AboutProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports